import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useDispatch } from 'react-redux';
import { setLazyLoad } from '@/vdp/Device/actions';

const BelowFoldViewHandler = ({ children, ...props }) => {
  const dispatch = useDispatch();
  const [ref, inView] = useInView({ threshold: 0.2, triggerOnce: true });

  useEffect(() => {
    if (inView) {
      dispatch(setLazyLoad(false));
    }
  }, [dispatch, inView]);

  return (
    <div ref={ref} {...props}>
      {children}
    </div>
  );
};

export default BelowFoldViewHandler;
